import { TTL } from '@/constants/config';
import { storage, storageKeys } from '@/constants/storage';
import { Logger } from '@/utils/logging';

import type { RwgAttribution } from './types';

const isFresh = (data: RwgAttribution): boolean =>
  Date.now() - data.capturedAt <= TTL.rwgAttribution;

const parse = (raw: string | undefined): RwgAttribution | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as RwgAttribution;
    if (typeof parsed?.token !== 'string' || !parsed.token) return null;
    if (typeof parsed?.capturedAt !== 'number') return null;
    return parsed;
  } catch (error) {
    Logger.warn('[rwg] failed to parse stored value', { error });
    return null;
  }
};

export const getRwg = (): RwgAttribution | null => {
  const data = parse(storage.getString(storageKeys.rwgAttribution));
  if (!data) return null;
  if (!isFresh(data)) {
    storage.remove(storageKeys.rwgAttribution);
    return null;
  }
  return data;
};

export const setRwg = (data: RwgAttribution): void => {
  storage.set(storageKeys.rwgAttribution, JSON.stringify(data));
};

export const clearRwg = (): void => {
  storage.remove(storageKeys.rwgAttribution);
};

/**
 * Records the shop that was on screen for a token captured without one. First
 * stamp wins: the shop presented alongside the Google link is what
 * `merchant_changed` compares against, so a later shop must not overwrite it.
 */
export const stampRwgShop = (shopId: string): void => {
  if (!shopId) return;
  const data = getRwg();
  if (!data || data.shopId) return;
  setRwg({ ...data, shopId });
};
